import React, {useRef} from "react";
import {JsxElement} from "typescript";
import {Box, Text} from "rebass";
import {CheckBoxInput, SliderInput} from "../../../../../Components/Inputs";
import {Form, Formik} from "formik";

export const SubSettingsWrapper: React.FC<{
  title: string
  color?: string
}> = ({title, children, color="black"}) => {
  return (
    <Box>
      <Text fontWeight="bold" fontSize={2} color={color} padding={2}>{title}</Text>
      {children}
    </Box>
  )
}

export const defaultVirtualPrism = {
  "Horizontal Deviation": 10,
  "Vertical Deviation": 0,
  "Cyclotorision": 0,
  "Enable Split Deviation": true
}
export const VirtualPrism: React.FC<{
}> = ({}) => {
  return (
    <SubSettingsWrapper title="Virtual Prism">
      <SliderInput name="Horizontal Deviation" min={-50} max={50} step={0.5}/>
      <SliderInput name="Vertical Deviation" min={-50} max={50} step={0.5}/>
      <SliderInput name="Cyclotorision" min={-20} max={20} step={0.5} unit="°"/>
      <CheckBoxInput name="Enable Split Deviation"/>
    </SubSettingsWrapper>
  )
}

export const defaultAntiSuppression = {
  "Contrast Ratio": 0,
  "Dark Filter": 0,
  "Blur Filter": 0
}
export const AntiSuppression: React.FC<{
}> = ({}) => {
  return (
    <SubSettingsWrapper title="Anti-Suppression">
      <SliderInput name="Contrast Ratio" min={0} max={100} step={1}/>
      <SliderInput name="Dark Filter" min={0} max={100} step={1}/>
      <SliderInput name="Blur Filter" min={0} max={100} step={1}/>
    </SubSettingsWrapper>
  )
}


export const GameSettingsWrapper: React.FC<{
  title: string
  initialValues: {}
  formReference: any
  color?: string
}> = ({title,initialValues, formReference, children, color="grey"}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={() => {}} innerRef={formReference}>
      <Form onChange={(e) => {
        const values = formReference.current.values
        values[e.target["name"]] = e.target["value"]
      }}>
        {children}
      </Form>
    </Formik>
  )
}
